export class ListSparkJobsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sparkJobs",
            "baseName": "sparkJobs",
            "type": "Array<SparkJob>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSparkJobsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
